import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface LinkType {
  activeLinkCondition?: boolean
  label: string
  to: string
  testId: string
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

interface SidebarProps {
  links: LinkType[]
}

const Sidebar: React.FC<SidebarProps> = ({ links }) => {
  const { pathname } = useLocation()
  return (
    <div className="h-full w-[60px] md:w-[180px] lg:w-[240px] pt-8 md:pt-14 px-3 lg:px-6 pb-4">
      <div className="flex flex-col justify-center items-start gap-8">
        {links?.map((link) => {
          const linkColor =
            link.activeLinkCondition || pathname === link.to ? 'text-accent' : 'text-white-yellow'
          return (
            <Link
              className={`hover:opacity-50 ${linkColor}`}
              key={`${link.to}`}
              to={link.to}
              data-testid={link.testId}
            >
              <div className="flex items-center justify-center gap-2">
                {link.Icon ? <link.Icon className="w-6 h-6" /> : null}
                <span className="hidden md:inline-block">{link.label}</span>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default Sidebar
